// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cya7","content":"styles_content__2-YDs","tableWrap":"styles_tableWrap__A-FFK"};